import type {
    InventoryResult,
    InventoryStore,
    StoreSearchResult,
} from '@libs/common-node';

import type { InventoryHit, InventoryHitStore } from '../types';

// Note: should be deleted?
export const transformStoreInventoryResult = (
    hit: InventoryHit
): InventoryHitStore[] => {
    const hitProperties = Object.keys(hit);
    const stores: InventoryHitStore[] = [];

    hitProperties.forEach((property: string) => {
        if (property.includes('store_')) {
            stores.push({
                id: parseInt(property.replace('store_', ''), 10),
                qty: hit[property as keyof typeof hit] as number,
            });
        }
    });

    return stores;
};

export const checkStoreInventory = ({
    inventoryStore,
    inventory,
    currentVariantId,
}: {
    inventory: InventoryResult[];
    inventoryStore: StoreSearchResult;
    currentVariantId: number;
}): number | boolean => {
    let relevantStore: InventoryStore | undefined;
    const relevantInventory = inventory.find(
        ({ sku, stores }) =>
            sku === currentVariantId &&
            stores.some(potentialStore => {
                const isRelevantStore =
                    Number(potentialStore.id) ===
                        inventoryStore.Store.StoreNumber &&
                    potentialStore.qty > 0;

                if (isRelevantStore) {
                    relevantStore = { ...potentialStore };
                }

                return isRelevantStore;
            })
    );

    return relevantInventory && relevantStore ? relevantStore.qty : false;
};
